import { Avatar as AntAvatar } from 'antd';
import styled from 'styled-components';
import { AvatarGroupProps } from './types';

const { Group: AntAvatarGroup } = AntAvatar;

export const AvatarGroup = styled(AntAvatarGroup)<AvatarGroupProps>`
  .ant-avatar {
    border: none;
    box-shadow: 0 0 0 1px var(--white-100);

    &:not(:first-child) {
      margin-left: calc(-1 * var(--spacing-02));
    }

    &:last-child {
      color: var(--white-100);
    }
  }

  .ant-badge {
    + .ant-avatar,
    + .ant-badge {
      margin-left: 0;
    }

    + .ant-avatar:last-child {
      margin-left: 0;
      font-size: var(--font-size-sm);
      height: var(--avatar-size-sm);
      line-height: var(--avatar-size-sm);
      width: var(--avatar-size-sm);
    }
  }

  .ant-avatar-sm + .ant-avatar:not(.ant-scroll-number-custom-component) {
    font-size: var(--font-size-sm);
    height: var(--avatar-size-sm);
    line-height: var(--avatar-size-sm);
    width: var(--avatar-size-sm);
  }

  .ant-avatar-lg
    + .ant-avatar:last-child:not(.ant-scroll-number-custom-component) {
    height: var(--avatar-size-lg);
    line-height: var(--avatar-size-lg);
    width: var(--avatar-size-lg);
  }
`;
